export default function ({ store, redirect, route }) {
  if (store.$auth.loggedIn && route.name !== '/register/fill-data') {
    if (store.$auth.user.first_name === '' || store.$auth.user.last_name === '') {
      redirect('/register/fill-data')
    }
  }
}
